import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(
    () => typeof window !== "undefined" && window.scrollY > 0
  );
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 0);

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navItems = [
    { label: "About", path: "/about" },
    { label: "Services", path: "/services" },
    { label: "How It Works", path: "/how-it-works" },
    { label: "FAQ", path: "/faq" },
    { label: "Contact Us", path: "/contact" },
  ];

  return (
    <header
      className={`bg-white fixed top-0 left-0 right-0 z-50 transition-shadow duration-200 ${
        scrolled ? "shadow-sm" : ""
      }`}
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          <div className="lg:flex lg:items-center lg:gap-12">
            <Link
              to="/"
              className="block"
              onClick={(e) => {
                setMobileMenuOpen(false); // header only, remove this line for footer
                if (location.pathname === "/") {
                  e.preventDefault();
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }
              }}
            >
              <span className="sr-only">Home</span>
              <img
                src="/lloyd-funding-logo-header-100.png"
                alt="Lloyd Funding"
                className="h-16 sm:h-20 w-auto"
              />
            </Link>
          </div>

          <div className="hidden lg:block mr-8">
            <nav aria-label="Global">
              <ul className="flex items-center gap-6 text-base font-medium">
                {navItems.map((item) => (
                  <li key={item.label}>
                    <Link
                      className={`transition ${
                        location.pathname === item.path
                          ? "text-blue-700 font-semibold"
                          : "text-slate-700 hover:text-blue-700"
                      }`}
                      to={item.path}
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          </div>

          <div className="flex items-center gap-1 sm:gap-4">
            {/* Apply Now - hidden below 430px (iPhone 14 Pro Max width) */}
            <div className="hidden min-[430px]:flex sm:gap-4">
              <Link
                className="rounded-xl bg-blue-600 px-5 py-2.5 text-sm font-semibold text-white shadow-sm shadow-blue-600/25 hover:bg-blue-700 hover:shadow-md hover:shadow-blue-600/30 transition-colors transition-shadow transition-[filter] duration-200 active:brightness-95"
                to="/contact#application-form"
              >
                Apply Now
              </Link>
            </div>

            <div className="block lg:hidden">
              <button
                className="rounded-md p-2 text-slate-700"
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="size-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  {mobileMenuOpen ? (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  ) : (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  )}
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Menu - outside container for full width */}
      <div
        className={`lg:hidden bg-white border-t border-slate-100 shadow-md overflow-hidden transition-[max-height,opacity] duration-200 ease-out ${
          mobileMenuOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <nav className="py-4">
            <ul className="space-y-1">
              {navItems.map((item) => (
                <li key={item.label}>
                  <Link
                    className={`block px-3 py-2 transition ${
                      location.pathname === item.path
                        ? "text-blue-700 font-semibold"
                        : "text-slate-700 hover:text-blue-700"
                    }`}
                    to={item.path}
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
              {/* Apply Now in mobile menu - only shows below 430px */}
              <li className="pt-2 min-[430px]:hidden">
                <Link
                  className="block w-full text-center rounded-xl bg-blue-600 px-5 py-2.5 font-semibold text-white shadow-sm shadow-blue-600/25 hover:bg-blue-700 transition-colors"
                  to="/contact#application-form"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Apply Now
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
